/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 7:50 PM
 *
 */

import { useMutation, useQueryClient } from 'react-query';

import { postNormalMember, postOrgMember } from 'features/members/api/requests/member.request';

export const useAddPatient = () => {
  const queryClient = useQueryClient();

  return useMutation(postNormalMember, {
    onSuccess: () => {
      queryClient.invalidateQueries('member-list-nested');
    },
  });
};

export const useNestedAddPatient = (parent_member_id: number) => {
  const queryClient = useQueryClient();

  return useMutation(postNormalMember, {
    onSuccess: () => {
      queryClient.invalidateQueries('member-list-nested');
    },
  });
};

export const useAddUser = () => {
  const queryClient = useQueryClient();

  return useMutation(postOrgMember, {
    onSuccess: () => {
      queryClient.invalidateQueries('member-list-nested');
    },
  });
};

export const useNestedAddUser = (parent_member_id: number) => {
  const queryClient = useQueryClient();

  return useMutation(postOrgMember, {
    onSuccess: () => {
      queryClient.invalidateQueries('member-list-nested');
    },
  });
};
